/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1917583362 — Cancel-settle UX */

import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, SmallButton } from '../../../../shared/ui';
import { CancelPage } from '../../../event-log';
import { useOrderActions } from '../../hooks/useOrderActions';

interface CancelButtonProps {
    /** Screen key, e.g. 'snack', 'payment-ct5'. Resolves to the event-log label. */
    page: CancelPage;
    /** Render the SmallButton variant (used by FeedbackAndReceipt) */
    small?: boolean;
    style?: CSSProperties;
}

/**
 * Single cancel button — owns the useOrderActions hook + the 2-second
 * apparatus-settle spinner. Drop-in replacement for the
 *   const { onCancelClickHandler, isCancelling } = useOrderActions();
 *   <Button onClick={() => onCancelClickHandler(page)} loading={isCancelling}>
 *     {t('Cancel')}
 *   </Button>
 * pattern that was duplicated across 8 sites.
 */
export const CancelButton = ({ page, small, style }: CancelButtonProps) => {
    const { t } = useTranslation();
    const { onCancelClickHandler, isCancelling } = useOrderActions();
    const Btn = small ? SmallButton : Button;
    return (
        <Btn
            onClick={() => onCancelClickHandler(page)}
            loading={isCancelling}
            style={style}
        >
            {t('Cancel')}
        </Btn>
    );
};
